module.exports = __webpack_public_path__ + "static/media/allimeister.c5c9fe76.svg";